import React, { useState, useEffect} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
import Select from "react-select";



const MatravelpackageexclusionCreate = ()=>{
    const [matravelpackage, setMatravelpackage ] = useState('');
    const [exclusion, setExclusion ] = useState('');
    const [matravelpackageList, setMatravelpackageList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [redirect, setRedirect] = useState(false);
    const [exclusions, setExclusions] = useState([{ value: "" }]);
    const handleExclusionChange = (index, value) => {
      const updated = [...exclusions];
      updated[index].value = value;
      setExclusions(updated);
    };
  
    const addExclusion = () => {
      setExclusions([...exclusions, { value: "" }]);
    };
  
    const removeExclusion = (index) => {
      const updated = exclusions.filter((_, i) => i !== index);
      setExclusions(updated);
    };
  
    const submit = async (e)=>{
         e.preventDefault();
         const payload = {
            travelPackageId: matravelpackage,
            exclusions: exclusions.map((inc) => inc.value).filter((v) => v !== ""),
          };
         const {data} = await axios.post('matravelpackageExclusionMulti', payload);
        console.log(data);
        setRedirect(true);
     }

     useEffect(() => {
        const fetchMatravelPackages = async () => {
           setLoading(true);
           setHasError(false);
           setErrorMessage('');
     
           try {
             const { data } = await axios.get(`maTravelPackage?page=${1}`);
             setMatravelpackageList(data.data);
               //console.log(data.data);
           } catch (error) {
             if (error.response) {
               // The request was made and the server responded with a status code
               // that falls out of the range of 2xx
               if (error.response.status === 401) {
                 setErrorMessage("Unauthorized access.");
               } else if (error.response.status === 400) {
                 setErrorMessage("Bad request. Please check your input.");
               }
               else if (error.response.status === 500) {
                 setErrorMessage("Insufficient Permissions");
               }
               else {
                 setErrorMessage("An error occurred. Please try again later.");
               }
             } else if (error.request) {
               // The request was made but no response was received
               if (error.message === "Network Error") {
                 setErrorMessage("Failed to connect to the server. Please try again later.");
               } else {
                 setErrorMessage("No response received. Please try again later.");
               }
             } else {
               // Something happened in setting up the request that triggered an Error
               setErrorMessage("An error occurred. Please try again later.");
             }
             setHasError(true);
           } finally {
             setLoading(false);
           }
         };
     
         fetchMatravelPackages();

    }, []);

    if(redirect){
        return <Navigate to={'/matravelpackageexclusion'} />
    }
     return (
         <Wrapper pageTitle={"New Matravelpackageexclusion"}>
            <InnerNav createLink={'/matravelpackageexclusionCreate'} listLink={'/matravelpackageexclusion'} />
                    <form onSubmit={submit}>
            <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
                {/* Travel Package */}
                <label className="block text-sm mb-4">
                <span className="text-gray-700 dark:text-gray-400">Travel Package</span>
                <Select
                    options={matravelpackageList.map((travelPackage) => ({
                    value: travelPackage.id,
                    label: `${travelPackage.name} ${travelPackage.name}`.trim(),
                    }))}
                    onChange={(selectedOption) =>
                    setMatravelpackage(selectedOption.value)
                    }
                />
                </label>

                {/* Inclusions */}
                <span className="text-gray-700 dark:text-gray-400 text-sm">Exclusions</span>
                {exclusions.map((inc, index) => (
                <div key={index} className="flex items-center mt-2">
                    <input
                    className="flex-1 p-2 border text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                    placeholder={`Exclusion ${index + 1}`}
                    value={inc.value}
                    onChange={(e) => handleExclusionChange(index, e.target.value)}
                    />
                    {exclusions.length > 1 && (
                    <button
                        type="button"
                        className="ml-2 px-3 py-1 text-sm text-white bg-red-500 rounded-lg hover:bg-red-400"
                        onClick={() => removeExclusion(index)}
                    >
                        ✕
                    </button>
                    )}
                </div>
                ))}

                {/* Add Inclusion button */}
                <button
                type="button"
                className="mt-3 px-3 py-1 text-sm text-white bg-green-600 rounded-lg hover:bg-green-500"
                onClick={addExclusion}
                >
                + Add Exclusion
                </button>

                {/* Save Button */}
                <div className="flex mt-6 text-sm">
                <button
                    type="submit"
                    className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white bg-blue-600 rounded-lg hover:bg-blue-500"
                >
                    <FiSave />
                    <span className="ml-3">Save</span>
                </button>
                </div>
            </div>
            </form>
        </Wrapper>
     );
};
export default MatravelpackageexclusionCreate;